<template>
  <!-- 送り状一括設定 -->
  <div id="HolterInvoiceBulkSetting">
    <div id="container">
      <div class="labelTitle lable">送り状一括設定</div>
      <div class="button-area">
        <b-upload style="margin-left:5px;float:left;" v-if="data" v-model="tsvfile" v-on:input="tsvRead">
          <a class="button patientListButton" style="paddinf-top:5px;border-color:rgb(118,118,118); color:black;"><b-icon class="file-icon" icon="file-import-outline" style="margin-right:3px;"></b-icon>TSV読込み</a>
        </b-upload>
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div class="invoiceBulkSettingTable-area">
        <b-table
          :data="data"
          id="invoiceBulkSettingTable"
          pagination-position="both"
          default-sort="reserveTime"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column label="#" width="50" centered>{{props.index +1}}</b-table-column>
            <b-table-column field="invoiceNumber" label="送り状番号" width="200" centered >
              <input :id="'invoiceNumber' + props.index" type="text" v-model="props.row.invoiceNumber" @keyup.enter="onKeyupEnter(props.index)" :disabled="!props.row.editFlag" maxlength="14"/>
            </b-table-column>
            <b-table-column field="paymentNumber" label="着払い番号" width="200" centered >
              {{props.row.paymentNumber }}
            </b-table-column>
            <b-table-column field="receiptNumber" label="受付番号" width="120" centered sortable>
              {{props.row.receiptNumber[0]}}
            </b-table-column>
            <b-table-column field="receiverName" label="配送先宛名" width="200" >
              {{props.row.receiverName }}
            </b-table-column>
            <b-table-column field="receiverAddress" label="配送先住所" >
              {{props.row.receiverAddress }}
            </b-table-column>
            <b-table-column field="instrumentKind" label="機種" width="150" >
              {{props.row.instrumentKind | getNameFilter(modelList) }}
            </b-table-column>
            <b-table-column field="shippingAddress" label="配送先タイプ" width="110" >
              {{props.row.shippingAddress }}
            </b-table-column>
          </template>
        </b-table>
        　
      </div>
      <div class="button-area">
        <b-button class="is-primary" @click="invoiceNumberBulkSet" :disabled="!data">送り状番号登録</b-button>
        <b-button class="backButton is-primary" @click="back" >戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {internalStatus} from "@/components/mock/base/const.js";
const columnDef =  {'paymentNumber': 0, 'invoiceNumber': 1}
export default {
  name: "HolterInvoiceBulkSetting",
  methods: {
    back: function () {
      this.$router.push({
        name: "HolterShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    tsvRead: function(){
      if(this.tsvfile.size < 1){
        this.showErrorMessage("空のTSVファイルです。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
      }
      var appVue = this.$root.$children[0]
      var invoiceNumberMap = {}
      let _this = this
      // ロード中か判定
      if (!appVue.$data.isLoading) {
        appVue.loadingStart()
      }
      try{
        // FileReader オブジェクトを作成
        let reader = new FileReader();
        reader.readAsText(this.tsvfile);
        reader.onload = function() {
          var recordArray =  reader.result.split('\n');
          let i = 0;
          for (; i < recordArray.length; i++){
            let columns = recordArray[i].split('\t');
            if(columns.length==1 && (columns[0]=="" || columns[0]=="\r")){
              // 改行のみの場合、スキップ
              continue
            }
            invoiceNumberMap[columns[columnDef.paymentNumber]] = columns[columnDef.invoiceNumber]
          }
          // 着払い番号の検索・送り状番号設定処理
          var hasUnMatching = false;
          var hasShipped = false;
          var setNumberFlag = false
          if(Object.keys(invoiceNumberMap).length>0){
            for(let item of _this.data){
              if(item.editFlag && invoiceNumberMap[item.paymentNumber]){
                item.invoiceNumber = invoiceNumberMap[item.paymentNumber]
                setNumberFlag = true
              }else if(item.editFlag && !item.invoiceNumber){
                hasUnMatching = true
              } else if (!item.editFlag && invoiceNumberMap[item.paymentNumber]){
                hasShipped = true;
              }
            }
          }
          let message = "TSVファイルを読込みました。<br/>"
          if(!setNumberFlag){
            if(message) {
              message += "<br/>"
            }
            message += "設定可能な送り状番号は存在しませんでした。";
          }
          if(hasUnMatching){
            if(message) {
              message += "<br/>"
            }
            message += "送り状番号が設定されなかったレコードが存在します。";
          }
          if(hasShipped){
            if(message) {
              message += "<br/>"
            }
            message += "出荷済みのためスキップしたレコードが存在します。";
          }
          appVue.loadingEnd()
          _this.showErrorMessage(message)
          _this.tsvfile = []
        };
        reader.onerror = function() {
          _this.tsvfile = []
          appVue.loadingEnd()
          this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
          return
        };
      }catch(err){
        this.tsvfile = []
        appVue.loadingEnd()
        this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
      }
    },
    onKeyupEnter: function(index){
      //フォーカスを移動
      let nextElement = document.getElementById("invoiceNumber" + (index + 1));
      if(nextElement){
        // 次のアイテムが存在する場合、フォーカスを移動
        nextElement.focus();
      }else{
        // 次のアイテムが存在しない場合、フォーカスを外す
        let element = document.getElementById("invoiceNumber" + (index));
        element.blur();
      }
    },
    invoiceNumberBulkSet: function() {
      this.bulkSetData = []
      var notInputInvoiceNumber = false
      var notEditData = false
      for(let item of this.data){
        if(item.invoiceNumber && item.editFlag){
          for(let receipt of item.receiptNumber){
            var req = {
              receiptNumber: receipt,
              paymentNumber: item.paymentNumber,
              invoiceNumber: item.invoiceNumber
            }
            this.bulkSetData.push(req)
          }
        }else if(!item.invoiceNumber && item.editFlag){
          notInputInvoiceNumber = true
        }else if(item.invoiceNumber && !item.editFlag){
          notEditData = true
        }
      }
      if(this.bulkSetData.length == 0){
        if(notInputInvoiceNumber){
          this.showErrorMessage("送り状番号が入力されていません。")
        }else if (notEditData){
          this.showErrorMessage("送り状番号登録対象が含まれていない為、<br>番号登録できません。")
        }
        return
      }
      var excuteApi = this.setHolterNumberPOST;
      var successCallBack = this.setHolterNumberPOSTSuccess;
      var errorCallBack = this.setHolterNumberPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterNumberPOST: function(client) {
      return client.apis.internalHolter.setHolterNumberPOST({
        body: this.bulkSetData
      });
    },
    setHolterNumberPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setHolterNumberPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var data = this.$route.params["data"];
    var searchParams = this.$route.params["searchConditions"];
    var modelList = this.$route.params["modelList"];
    return {
      data,
      searchParams,
      modelList,
      internalStatus,
      tsvfile: null,
      bulkSetData:[]
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.patientListButton {
  width: 140px !important;
  height:35px !important;
  -webkit-appearance: button !important; 
}
.invoiceBulkSettingTable-area {
  margin-top: 20px;
  width: 1350px;
  max-height: 650px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holter/shipping/HolterInvoiceBulkSetting.vue